import React from 'react'
import { Pressable, Text, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import { useRouter } from '@/utils/navigation'
import { ArrowBack, Close } from '@/components/icon'
import ScreenHeader from '@/components/ScreenHeader'

type NavigationBarProps = {
  handleAction?: () => void
  hasBottomBorder?: boolean
  iconId?: 'x' | 'chevronLeft'
  rightElement?: React.ReactNode
  children?: string
}

function NavigationBar({
  handleAction,
  hasBottomBorder = false,
  iconId = 'chevronLeft',
  rightElement,
  children
}: NavigationBarProps) {
  const router = useRouter()
  const { top } = useSafeAreaInsets()

  const Icon = iconId === 'chevronLeft' ? ArrowBack : Close

  return (
    <View className={'bg-background-primary'} style={{ paddingTop: top }}>
      <ScreenHeader
        hasBottomBorder={hasBottomBorder}
        leftElement={
          <Pressable
            className={'size-10 items-center justify-center text-text-tertiary'}
            onPress={handleAction ?? (() => router.back())}
          >
            <Icon />
          </Pressable>
        }
        centerElement={<Text className={'text-base font-medium text-text-primary'}>{children}</Text>}
        rightElement={rightElement}
      />
    </View>
  )
}

export default NavigationBar
